/**
 * Cartes-fiches des pages services (section zigzag) : la carte « se construit » à
 * son arrivée à l'écran (audit design du 28/10/2026, piste 1, validée par Olivier).
 * La photo s'ouvre depuis son bord extérieur avec un léger recul de zoom, puis
 * surtitre, titre, texte, chiffres clés et bouton arrivent en cascade, et les
 * chiffres clés comptent jusqu'à leur valeur.
 *
 * ⚠️ L'état « caché » n'existe que si CE script le pose (classe `km-build`) : si le
 * bundle arrive après le délai de la garde anti-flash (`__pdwAnimSkip`, header.php)
 * les cartes restent simplement visibles. Jamais de contenu bloqué.
 */
(function () {
    const blocks = document.querySelectorAll('.km-zigzag__block[data-km-build]');
    if (!blocks.length || window.__pdwAnimSkip) return;
    // ⚠️ Pas d'exception prefers-reduced-motion : politique d'Olivier, micro-animations
    // partout (son iPhone a « Réduire les animations » actif), cf. _theme-anim-km-materiaux.scss.
    if (!('IntersectionObserver' in window)) return;

    // Compte le PREMIER nombre du chiffre clé (« 2,5 m³ » garde sa décimale), seulement
    // si le reste n'en contient pas d'autre : « 50–450 kg » ou « 7h – 16h » restent fixes.
    const countUp = (el) => {
        const node = el.firstChild;
        if (!node || node.nodeType !== 3) return;
        const m = node.nodeValue.match(/^(\d+)(?:,(\d+))?(\D*)$/);
        if (!m) return;
        const rest = Array.from(el.childNodes).slice(1).map((n) => n.textContent).join('');
        if (/\d/.test(rest)) return;
        const final = node.nodeValue;
        const dec = m[2] ? m[2].length : 0;
        const target = parseFloat(m[1] + '.' + (m[2] || '0'));
        el.style.minWidth = el.offsetWidth + 'px'; // l'unité ne bouge pas pendant le comptage
        const fmt = (v) => v.toFixed(dec).replace('.', ',') + m[3];
        node.nodeValue = fmt(0);
        const dur = 1200;
        let t0 = null;
        const step = (t) => {
            if (!t0) t0 = t;
            const p = Math.min(1, (t - t0) / dur);
            node.nodeValue = p < 1 ? fmt(target * (1 - Math.pow(1 - p, 3))) : final;
            if (p < 1) requestAnimationFrame(step);
        };
        setTimeout(() => requestAnimationFrame(step), 430);
    };

    const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
            if (!en.isIntersecting) return;
            const b = en.target;
            io.unobserve(b);
            b.classList.add('is-in');
            b.querySelectorAll('.km-zigzag__spec-value').forEach(countUp);
        });
    }, {threshold: .25});

    blocks.forEach((b) => {
        b.classList.add('km-build');
        io.observe(b);
    });

    // Filet de sécurité : aucune carte ne reste cachée si l'observateur ne se déclenche pas
    // (onglet en arrière-plan, impression, capture).
    setTimeout(() => blocks.forEach((b) => b.classList.add('is-in')), 8000);
})();
